import soldBoughtAt from '@/components/contracts-history/sold-bought-at/sold-bought-at.vue';
import { dateToString, isMarketSingle } from '@/utils/helpers';

export default {
  props: {
    showMarketName: {
      type: Boolean,
      default: true,
    },
    data: Object,
    desktop: {
      type: Boolean,
      default: false,
    },
    compactMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    soldBoughtAt,
  },
  computed: {
    classModifiers() {
      return {
        'contract-tile': true,
        'contract-tile--compact': this.compactMode,
      };
    },
    accountHistoryRoute() {
      if (this.$route.fullPath === '/account/history') {
        return {
          name: 'account-history',
          params: { marketId: this.data.marketId },
        };
      }
      return {
        name: 'account-history',
        params: { marketId: this.data.marketId },
        query: { contractId: this.data.contractId },
      };
    },
    profit() {
      switch (this.data.tradeType) {
        case 0: // Buy No
        case 1: // Buy Yes
          return ' –';
        default: {
          const fee = (this.data.tradingFees !== 0) ? this.data.tradingFeesString : '';
          const gainLoss = this.data.tradeGainLossString;
          return (this.data.tradeGainLoss) ? `${gainLoss} ${fee}` : gainLoss;
        }
      }
    },
    profitClass() {
      return {
        'contract-tile__profit-desk': true,
        'contract-tile__profit-desk--plus': this.data.tradeGainLoss > 0,
      };
    },
    profitDesk() {
      return this.data.tradeType > 1 ? this.data.tradeGainLossString : '-';
    },
    fee() {
      return this.data.tradingFees < 0 ? this.data.tradingFeesString : '';
    },
    date() {
      return dateToString(this.data.dateExecuted);
    },
    market() {
      return this.data.marketName ? this.data.marketName : 'null';
    },
    isMarketSingle() {
      return isMarketSingle(this.data);
    },
    contractName() {
      if (this.data.marketType !== 0) {
        return this.data.contractName;
      }
      const type = this.data.tradeType;
      return (type === 0 || type === 2) ? 'No' : 'Yes';
    },
    shortProfit() {
      const tradeType = this.data.tradeType;
      return {
        'contract-tile__profit--short': tradeType === 0 || tradeType === 1,
      };
    },
    longName() {
      const tradeType = this.data.tradeType;
      return {
        'contract-tile__name--long': tradeType === 0 || tradeType === 1,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/contracts-history/contract-tile/contract-tile.js